import { useSelector, useDispatch } from 'react-redux';
import { useState ,useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { visualizerActions } from "../../store";
import RoomScene from "../RoomScene/RoomScene"

import styles from './RoomSceneList.module.css'

// Generate a list of roomscenes
export default function RoomSceneList({seriesId, thumbnailSize, scenes}) {

    const dispatch = useDispatch();
    const[sceneData, setSceneData] = useState([]);
    const navigate = useNavigate();
    const location = useLocation();
    const surfaces = useSelector(state => state.visualizer.surfaceList);
    // Pull the roomscene series for the passed series id
    useEffect(()=>{
        const URL = `https://lizard.chameleonpower.com/CDN/RoomScenes/${seriesId}.json`;
        fetch(URL)
        .then((response) => response.json())
        .then((data) => {
            
            const filtered = [];
            for (const scene of data) {
                if(scenes.includes('all') || scenes.includes(scene.description))
                    filtered.push(scene)
            }
           
            setSceneData(filtered);
            
        })
        
    },[scenes])

    const resetViz = () => {
        //clear all selections,states and dump history
        console.log('RESETTING VIZ...')
        //close compare
        dispatch(visualizerActions.setCompareData({ key: 'active', value: false }));
        dispatch(visualizerActions.snapshotAppliedProducts());
        dispatch(visualizerActions.clearProductDropdownFilters([]));
        dispatch(visualizerActions.clearProductSearchFilters());
        dispatch(visualizerActions.clearAppliedSnapshots());
        dispatch(visualizerActions.clearAppliedProducts());
        dispatch(visualizerActions.setActiveProductMenuTab('flooring'));
        dispatch(visualizerActions.setActiveSurface(surfaces[0]));
        dispatch(visualizerActions.setActiveFlooringSubMenuTab(null));
        
    };
   

    // Handles roomscene select event
    const handleRoomsceneSelect = function(specifier) {
        resetViz();
        navigate({
            pathname: `/visualizer/spec/${encodeURIComponent(specifier)}/sel/-1`,
            search: location.search,
            hash: location.hash,
        });
    }

    // Generates an array of RoomScene template items
    let rsItems = sceneData.map(scene => <RoomScene 
        key={scene.productId} 
        specifier={scene.specifier} 
        thumbnailSize={thumbnailSize} 
        onSelect={handleRoomsceneSelect}
        isActive={false}
        />)

    return(
        <div className={styles.roomsceneListContainer}>
            <ol className={styles.roomsceneList}>
                {rsItems}
            </ol>
        </div>
    )
}

// #TODO
// Manage roomscenen active status, Usage of context API?

